import React, { useContext, useEffect, useState } from 'react';
import Slider from "react-slick";
import {  AwsFileUrl, BASE_URL_STATIC, Image_Base_Url } from '../../../../../config';
import { GoogleMap, Marker } from "@react-google-maps/api";
import { InView } from "react-intersection-observer";
import { ApiContext } from '../../../UseContext/ApiCall';
import CreateNewPostPopup from '../../../CreateNewPost/Popup/CreateNewPostPopup';
import CnpFeelingActivityPopup from '../../../CreateNewPost/Popup/FeelingActivity/CnpFeelingActivityPopup';
import CnpTagPopup from '../../../CreateNewPost/Popup/Tag/CnpTagPopup';
import CnpLocationPopup from '../../../CreateNewPost/Popup/Location/CnpLocationPopup';
import CnpSelectMusicPopup from '../../../CreateNewPost/Popup/Music/CnpSelectMusicPopup';
import CnpCameraPopup from '../../../CreateNewPost/Popup/Camera/CnpCameraPopup';
import CnpPhotoVideoPopup from '../../../CreateNewPost/Popup/PhotoVideo/CnpPhotoVideoPopup';
import CnpMemePopup from '../../../CreateNewPost/Popup/Meme/CnpMemePopup';
import CnpFlixPopup from '../../../CreateNewPost/Popup/Flix/CnpFlixPopup';
import CnpBestclipPopup from '../../../CreateNewPost/Popup/Bestclip/CnpBestclipPopup';
import CnpSelectGifPopup from '../../../CreateNewPost/Popup/Gif/CnpSelectGifPopup';
import CnpGifPopup from '../../../CreateNewPost/Popup/Gif/CnpGifPopup';
import CnpSelectCollagePopup from '../../../CreateNewPost/Popup/Collage/CnpSelectCollagePopup';
import CnpAddCollageImagePopup from '../../../CreateNewPost/Popup/Collage/CnpAddCollageImagePopup';
import CnpCollagePopup from '../../../CreateNewPost/Popup/Collage/CnpCollagePopup';
import CnpAdvanceSettingPopup from '../../../CreateNewPost/Popup/CnpAdvanceSettingPopup';
import HomeVideoTagPopup from '../../../Others/Home/Popup/HomeVideoTagPopup';
import HomePhotoVideoGridPopup from '../../../Others/Home/Popup/HomePhotoVideoGridPopup';
import PostViewUsersPopup from '../../../Others/Home/Popup/PostViewUsersPopup';
import PostLikeUsersPopup from '../../../Others/Home/Popup/PostLikeUsersPopup';
import Userpopup from '../../../Popup/Userpopup';
import ProfilePostPopup from '../../../Popup/Profile/ProfileShow/ProfilePostPopup';



const CenterBlockPosts = () => {  

  const {
    showHomeTagsOnPhoto, setShowHomeTagsOnPhoto,
    setShowHomeVideoTagPopup,
    setHomeVideoAddedTags,
    setShowHomeGridPopup,
    setHomeGridPost,

    showCnpLoadMore, setShowCnpLoadMore,
    homePosts, setHomePosts,
    homePostsSkip,
    getHomePosts,

    handleFollowUnfollow,

    // ----- Post > View -----
    setShowPostViewUsersPopup,
    postViewUserText, 
    postViewUsers,
    setPostViewUserPostId,
    handlePostView,
    getPostViewUsers,

    // ----- Post > Like -----
    handlePostLikeDislike,
    setShowPostLikeUsersPopup,
    setPostLikeUserPostId,
    getPostLikeUsers,

    // ----- Post > Favourite -----
    postFavouriteToggle,


    // ----- Old code se liya hu -----
    loggedInUserId,
    setShowProfilePostThreeDotPopup,
    postsPopupData, setPostsPopupData,

  } = useContext(ApiContext);


  const [seeMoreLess, setSeeMoreLess] = useState({});
  
  // handle see more less
  const handleSeeMoreLess = (_id) => {
    setSeeMoreLess((prev) => ({
      ...prev,
      [_id]: !prev[_id],
    }));
  };

  // handle click photo tag icon
  const handleClickPhotoTagIcon = (postId) => {
    setShowHomeTagsOnPhoto(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  // handle click video tag icon
  const handleClickVideoTagIcon = (tags) => {
    setShowHomeVideoTagPopup(true);

    setHomeVideoAddedTags(tags);
  };

  // handle click load more
  const handleLoadMore = () => {
    setShowCnpLoadMore(false);
    
    getHomePosts(homePostsSkip);
  };

  // handle click photo/video grid post
  const handleClickGridPost  = (gridPost) => {
    setShowHomeGridPopup(true);
    
    setHomeGridPost(gridPost);
  };

  // handle click post view users
  const handleClickPostView = (postId) => {
    setShowPostViewUsersPopup(true);

    // jb postViewUsersPopup open hoga to search or load more feature ke liye postId store krwa rha hu 
    setPostViewUserPostId(postId);

    getPostViewUsers(postId, postViewUserText, postViewUsers.length);
  };

  // handle click post like users
  const handleClickPostLike = (postId) => {
    setShowPostLikeUsersPopup(true);

    // jb postLikeUsersPopup open hoga to search or load more feature ke liye postId store krwa rha hu 
    setPostLikeUserPostId(postId);

    getPostLikeUsers(postId, postViewUserText, postViewUsers.length);
  };

  // handle click post favourite
  const handleClickPostFavourite = (postId) => {
    // update in front end
    setHomePosts(prevPosts =>
      prevPosts.map(post =>
        post._id === postId
        ? 
        { ...post, favourite: !post.favourite }
        : 
        post
      )
    );

    // update in back end
    postFavouriteToggle(postId);
  };


  // ----- Old code se liya hu -----

  const [showPopup, setShowPopup] = useState(false);
  const [showPostsPopup, setShowPostsPopup] = useState(false);
  const [postId, setPostId] = useState('');

  // handle click three dot
  const handleClickThreeDot = (user, post) => {
    switch (user) {
      case 'loggedInUser': {

        setShowPopup(true);

        setPostsPopupData(post);
        
        break;
      }
      case 'otherUser': {

        setShowProfilePostThreeDotPopup(true);

        setPostsPopupData(post);

        break;
      }
      default: {

        break;
      }
    }
  }

  // handle click comment
  const handleClickComment = (post) => {
    setShowPostsPopup(true);
    setPostsPopupData(post);
    setPostId(post._id)
  };

  // photo/video slider setting
  const photoVideoSetting = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    dots: true,
  }; 


  useEffect(() => {
    getHomePosts(homePostsSkip);
  }, []);


  return (
    <>
      {/* Popup > Create New Post */}
      <>
        {/* Create New Post Popup */}
        <CreateNewPostPopup />

        {/* Cnp > Fellings/Activities Popup */}
        <CnpFeelingActivityPopup />

        {/* Cnp > Tag Popup */}
        <CnpTagPopup />

        {/* Cnp > Check in/Location Popup */}
        <CnpLocationPopup />

        {/* Cnp > Select Music Popup */}
        <CnpSelectMusicPopup />

        {/* Cnp > Camera Popup */}
        <CnpCameraPopup />

        {/* Cnp > Photo/Video Popup */}
        <CnpPhotoVideoPopup />

        {/* Cnp > Meme Popup */}
        <CnpMemePopup />

        {/* Cnp > Flix Popup */}
        <CnpFlixPopup />

        {/* Cnp > Bestclip Popup */}
        <CnpBestclipPopup />

        {/* Cnp > Select Gif Popup */}
        <CnpSelectGifPopup />

        {/* Cnp > Gif Popup */}
        <CnpGifPopup />

        {/* Cnp > Select Collage Popup */}
        <CnpSelectCollagePopup />
        
        {/* Cnp > Add Collage Image Popup */}
        <CnpAddCollageImagePopup />

        {/* Cnp > Collage Popup */}
        <CnpCollagePopup />

        {/* Cnp > Advance Setting Popup */}
        <CnpAdvanceSettingPopup />
      </>

      {/* Popup > Home */}
      <>
        {/* Video Tag Popup */}
        <HomeVideoTagPopup />

        {/* Photo/Video > Grid Popup */}
        <HomePhotoVideoGridPopup />

        {/* Post > View > Users */}
        <PostViewUsersPopup />

        {/* Post > Like > Users */}
        <PostLikeUsersPopup />
      </>

      {/* Popup > Home > old code se liya hu */}
      <>
        {/* Three dot popup > logged in user */}
        <Userpopup showPopup={showPopup} setShowPopup={setShowPopup} postsPopupData={postsPopupData} setPostsPopupData={setPostsPopupData}/>

        {/* Post image popup */}
        <ProfilePostPopup 
          postId={postId} 
          showPostsPopup={showPostsPopup} setShowPostsPopup={setShowPostsPopup} 
          postsPopupData={postsPopupData} setPostsPopupData={setPostsPopupData} 
        />
      </>


      <section className=''>
        {
          (homePosts && homePosts.length > 0)
          && 
          <>
            {
              homePosts.map((value, index) => (
                <InView onChange={(inView) => handlePostView(inView, value._id)} triggerOnce={true} threshold={0} as="div" >
                  <div className='mb-3 py-2 bg-white shadow-sm rounded-3' key={index} > 
                    {/* {console.log('value : ', value)} */}

                    {/* profile, name, feeling, activity, check in/location, posted time */}
                    <div className='d-flex align-items-center px-2 gap-1'>
                      {/* Profile */}
                      <div>
                        <img src={AwsFileUrl+value.profile} className='rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />
                      </div>

                      {/* name, feeling, activity, check in/location, posted time */}
                      <div className='mx-3 me-auto'>
                        {/* Name */}
                        <span className='fs-5 mb-0 me-2 d-inline'>{value.name}</span>

                        {/* Feeling */}
                        <>
                          {
                            (value.feeling && value.feeling._id !== '')
                            &&
                            (
                              <span className='me-2 d-inline'>
                                <span className='text-secondary'>is</span> feeling {value.feeling.feelingName} {" "}
                                <img src={value.feeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                              </span>
                            )
                          }
                        </>

                        {/* Activity */}
                        <>
                          {
                            (value.activityCategory && value.activityCategory._id !== '' && value.activity && value.activity._id !== '')
                            &&
                            (
                              <span className='me-2 d-inline'>
                                <span className='text-secondary'>is</span> {value.activityCategory.activityCategoryName} {" "}
                                <img src={value.activityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {" "}
                                {value.activity.activityName} {" "}
                                <img src={value.activity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                              </span>
                            )
                          }
                        </>

                        {/* Check in/Location */}
                        <>
                          {
                            (value.location && value.location.place !== '' && value.location.lat !== '' && value.location.lng !== '')
                            &&
                            <>
                              <span className='text-secondary d-inline'>at</span> {' '}
                              {value.location.place}
                              {/* {value.location.place && value.location.place.split(" ").slice(0, 5).join(" ")} */}
                              {/* {value.location.place && value.location.place.split(" ").length > 5 && "..."} */}
                            </>
                          }
                        </>

                        {/* show posted time */}
                        <div>{value.postedAt}</div>
                      </div>

                      {/* Follow/Unfollow Button */}
                      <>
                        {
                          (value.buttonText !== '')
                          &&
                          <button type="button" className='btn btn-primary btn-sm text-nowrap' onClick={() => handleFollowUnfollow(value.userId)}>{value.buttonText}</button>
                        }
                      </>

                      {/* Three dot popup */}
                      <img src={`${Image_Base_Url}/icons/three-dot-black.svg`} className='cursor-pointer' style={{ height: '20px', width: '20px' }} alt="threeDot" 
                        onClick={() => handleClickThreeDot(loggedInUserId === value.postedBy ? 'loggedInUser' : 'otherUser', value )}
                      />
                    </div>

                    {/* Check in/Location image */}
                    <>
                      {
                        (value.postType === 'location' && value.location && value.location.placeImage) 
                        &&
                        <div className='my-4'>
                          <GoogleMap
                            center={{ lat: value.location.lat, lng: value.location.lng }}
                            mapContainerStyle={{ height: "250px", width: "100%" }}
                            zoom={15}
                            options={{ 
                              mapTypeId: "satellite",
                              fullscreenControl: true, 
                            }}
                          >
                            <Marker position={{ lat: value.location.lat, lng: value.location.lng }} />
                          </GoogleMap>
                        </div>
                      }
                    </>

                    {/* Music Image */}
                    <>
                      {
                        (value.postType === 'music' && value.music && value.music.musicImage === true)
                        &&
                        <div className='my-3 text-center border bg-light'>
                          <img src={value.music.image} alt='musicImage' />
                        </div>
                      }
                    </>

                    {/* Camera/Photo/Video > Carousel */}
                    <>
                      {
                        (value.carouselGrid === 'carousel' && value.photoVideo && value.photoVideo.length > 0)
                        &&
                        <Slider className='home-photoVideo-slider border my-3' {...photoVideoSetting}>              
                          {
                            value.photoVideo.map((photoVideoValue, photoVideoIndex) => (
                              <div className='text-center position-relative' key={photoVideoIndex}>
                                {
                                  photoVideoValue.fileUrl.includes('mp4')
                                  ?
                                  // Video
                                  <>
                                    <video src={AwsFileUrl+photoVideoValue.fileUrl} />

                                    {/* tag Icon */}
                                    <>
                                      {
                                        (photoVideoValue.tags.length > 0)
                                        &&
                                        <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer' onClick={() => handleClickVideoTagIcon(photoVideoValue.tags)}>
                                          <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                                        </div>
                                      }
                                    </>
                                  </>
                                  :
                                  // Photo
                                  <>
                                    <img 
                                      src={photoVideoValue.fileUrl.includes('gif') ? photoVideoValue.fileUrl : AwsFileUrl+photoVideoValue.fileUrl} 
                                      className={`${value.postType === 'collage' ? 'border border-dark' : ''} object-fit-contain`} alt="photoVideo" 
                                    />

                                    {/* Tags */}
                                    <>
                                      {
                                        (showHomeTagsOnPhoto[value._id] && photoVideoValue.tags.length > 0)
                                        &&
                                        photoVideoValue.tags.map((tagValue, tagIndex) => (
                                          <div className='position-absolute pt-1 px-2 bg-secondary rounded-2 d-flex align-items-center gap-2 text-white' key={tagIndex}
                                            style={{ 
                                              top: `${tagValue.offsetY}%`, 
                                              left: `${tagValue.offsetX}%`, 
                                              zIndex: `${tagIndex}`,
                                              fontSize: '13px',
                                              transform: 'translate(-50%, -0%)'
                                            }} 
                                          >
                                            <span>{tagValue.userName}</span>
                                            {/* <span className='cursor-pointer'>✖</span> */}
                                          </div>
                                        ))
                                      }
                                    </>

                                    {/* tag Icon */}
                                    <>
                                      {
                                        (photoVideoValue.tags.length > 0)
                                        &&
                                        <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer' onClick={() => handleClickPhotoTagIcon(value._id)}>
                                          <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                                        </div>
                                      }
                                    </>
                                  </>
                                }
                              </div>
                            ))
                          }
                        </Slider>
                      }
                    </>

                    {/* Camera/Photo/Video > Grid (2) */}
                    <>
                      {
                        (value.carouselGrid === 'grid' && value.photoVideo && value.photoVideo.length === 2)
                        &&
                        <div className='border my-3 bg-light d-flex align-items-center justify-content-center' style={{ height: '40vh' }} onClick={() => handleClickGridPost(value)} >
                          <div style={{ height: '40vh' }}>
                            {
                              (value.photoVideo[0].fileUrl.includes('mp4'))
                              ?
                              <video src={AwsFileUrl+value.photoVideo[0].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '40vh', width: '25vw' }} ></video>
                              :
                              <img src={AwsFileUrl+value.photoVideo[0].fileUrl} className='border object-fit-cover' style={{ height: '40vh', width: '25vw' }} alt="photoVideo" />
                            }
                          </div>

                          <div style={{ height: '40vh' }}>
                            {
                              (value.photoVideo[1].fileUrl.includes('mp4'))
                              ?
                              <video src={AwsFileUrl+value.photoVideo[1].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '40vh', width: '25vw' }} ></video>
                              :
                              <img src={AwsFileUrl+value.photoVideo[1].fileUrl} className='border object-fit-cover' style={{ height: '40vh', width: '25vw' }} alt="photoVideo" />
                            }
                          </div>
                        </div>
                      }
                    </>

                    {/* Camera/Photo/Video > Grid (3) */}
                    <>
                      {
                        (value.carouselGrid === 'grid' && value.photoVideo && value.photoVideo.length === 3)
                        &&
                        <div className='border my-3 bg-light d-flex align-items-center justify-content-center' style={{ height: '40vh' }} onClick={() => handleClickGridPost(value)} >
                          <div style={{ height: '40vh' }}>
                            {
                              (value.photoVideo[0].fileUrl.includes('mp4'))
                              ?
                              <video src={AwsFileUrl+value.photoVideo[0].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '40vh', width: '25vw' }} ></video>
                              :
                              <img src={AwsFileUrl+value.photoVideo[0].fileUrl} className='border object-fit-cover' style={{ height: '40vh', width: '25vw' }} alt="photoVideo" />
                            }
                          </div>

                          <div className='d-flex flex-column'>
                            <div style={{ height: '20vh' }}>
                              {
                                (value.photoVideo[1].fileUrl.includes('mp4'))
                                ?
                                <video src={AwsFileUrl+value.photoVideo[1].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                                :
                                <img src={AwsFileUrl+value.photoVideo[1].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                              }
                            </div>

                            <div style={{ height: '20vh' }}>
                              {
                                (value.photoVideo[2].fileUrl.includes('mp4'))
                                ?
                                <video src={AwsFileUrl+value.photoVideo[2].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                                :
                                <img src={AwsFileUrl+value.photoVideo[2].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                              }
                            </div>
                          </div>
                        </div>
                      }
                    </>

                    {/* Camera/Photo/Video > Grid (4 or more) */}
                    <>
                      {
                        (value.carouselGrid === 'grid' && value.photoVideo && value.photoVideo.length >= 4)
                        &&
                        <div className='border my-3 bg-light d-flex align-items-center justify-content-center' style={{ height: '40vh' }} onClick={() => handleClickGridPost(value)} >
                          <div className='d-flex flex-column'>
                            <div style={{ height: '20vh' }}>
                              {
                                (value.photoVideo[0].fileUrl.includes('mp4'))
                                ?
                                <video src={AwsFileUrl+value.photoVideo[0].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                                :
                                <img src={AwsFileUrl+value.photoVideo[0].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                              }
                            </div>

                            <div style={{ height: '20vh' }}>
                              {
                                (value.photoVideo[1].fileUrl.includes('mp4'))
                                ?
                                <video src={AwsFileUrl+value.photoVideo[1].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                                :
                                <img src={AwsFileUrl+value.photoVideo[1].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                              }
                            </div>
                          </div>

                          <div className='d-flex flex-column'>
                            <div style={{ height: '20vh' }}>
                              {
                                (value.photoVideo[2].fileUrl.includes('mp4'))
                                ?
                                <video src={AwsFileUrl+value.photoVideo[2].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                                :
                                <img src={AwsFileUrl+value.photoVideo[2].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                              }
                            </div>

                            <div className={`${value.photoVideo.length > 4 ? 'position-relative' : ''}`} style={{ height: '20vh' }}>
                              {
                                (value.photoVideo[3].fileUrl.includes('mp4'))
                                ?
                                <video src={AwsFileUrl+value.photoVideo[3].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                                :
                                <img src={AwsFileUrl+value.photoVideo[3].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                              }

                              <>
                                {
                                  (value.photoVideo.length > 4)
                                  &&
                                  <span className='position-absolute top-50 start-50 translate-middle h-100 w-100 d-flex align-items-center justify-content-center text-white' 
                                    style={{ fontSize: '30px', backgroundColor: '#80808080' }}
                                  >+{value.photoVideo.length-4}</span>
                                }
                              </>
                            </div>
                          </div>
                        </div>
                      }
                    </>

                    {/* Text with background */}
                    <>
                      {
                        value.postType === 'textWithBackground'
                        &&
                        <div className={`my-3 d-flex align-items-center justify-content-center text-center text-break text-white fs-2 px-3`} 
                          style={{ 
                            height: '40vh', 
                            backgroundImage: `url('${value.textBackgroundImage}')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            whiteSpace: 'pre-wrap',
                          }}
                        >{value.text}</div>
                      }
                    </>

                    {/* Music Text (eg : - icon - name - play - close ) */}
                    <>
                      {
                        (value.music && value.music._id && value.music._id !== '')
                        &&
                        <div className='d-flex align-items-center gap-3 my-3 px-2'>
                          <img src='/images/icons/music.svg' style={{ height: '17px', width: '17px' }} alt='music' />

                          <span className='me-auto text-truncate'>{value.music.name}</span>

                          <img src={`/images/icons/unmute.svg`} className="cursor-pointer" style={{ height: "25px" }} alt="muteUnmute" />
                        </div>
                      }
                    </>

                    {/* Text */}
                    <>
                      {
                        (value.postType === 'text' && value.text)
                        &&
                        <div className='my-3 text-break px-2'>
                          {seeMoreLess[value._id] ? value.text : value.text.slice(0, 50) + (value.text.length > 50 ? "..." : "")}

                          {
                            value.text.length > 50 
                            && 
                            <small className="text-primary cursor-pointer" onClick={() => handleSeeMoreLess(value._id)}>
                              {seeMoreLess[value._id] ? " See less..." : " See more..."}
                            </small>
                          }
                        </div>
                      }
                    </>

                    {/* View, Like, Comment, Share, Favourite, Download */}
                    <div className='d-flex align-items-center gap-2 gap-sm-3 gap-md-4 gap-lg-5 my-3 px-2'>
                      {/* View */}
                      <div className='d-flex align-items-center gap-1'>
                        <img src={`${BASE_URL_STATIC}/icon/view-${value.viewed ? '2' : '1'}.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                        <span className='cursor-pointer' onClick={() => handleClickPostView(value._id)}>{value.viewCount}</span>
                      </div>

                      {/* Like */}
                      <div className='d-flex align-items-center gap-1'>
                        <img src={`${BASE_URL_STATIC}/icon/like-${value.liked ? '2' : '1'}.svg`} className='cursor-pointer' style={{ height: '23px', width: '23px' }} onClick={() => handlePostLikeDislike(value._id)} alt="view" />

                        <>
                          {
                            (!value.hidelikeCount)
                            &&
                            <span className='cursor-pointer' onClick={() => handleClickPostLike(value._id)}>{value.likeCount}</span>
                          }
                        </>
                      </div>

                      {/* Comment */}
                      <div className='d-flex align-items-center gap-1 cursor-pointer' onClick={() => handleClickComment(value)}>
                        <img src={`${BASE_URL_STATIC}/icon/comment-1.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                        <span>0</span>
                      </div>

                      {/* Share */}
                      <div className='d-flex align-items-center gap-1 flex-grow-1 cursor-pointer'>
                        <img src={`${BASE_URL_STATIC}/icon/share-1.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                        <span>0</span>
                      </div>

                      {/* Favourite */}
                      <img src={`${BASE_URL_STATIC}/icon/favourite-${value.favourite ? '2' : '1'}.svg`}  alt="view"
                        className='cursor-pointer' style={{ height: '23px', width: '23px' }} onClick={() => handleClickPostFavourite(value._id)}  
                      />

                      {/* Download */}
                      <img src={`${BASE_URL_STATIC}/icon/download-1.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                    </div>

                    {/* Text > photo/video, meme, flix, bestclip, gif, collage, location & music */}
                    <>
                      {
                        (
                          value.postType === 'photoVideo' 
                          || 
                          value.postType === 'meme' 
                          || 
                          value.postType === 'flix' 
                          || 
                          value.postType === 'bestclip' 
                          || 
                          value.postType === 'gif' 
                          || 
                          value.postType === 'collage' 
                          || 
                          (value.postType === 'location' && value.location && value.location.placeImage === true) 
                          || 
                          (value.postType === 'music' && value.music && value.music.musicImage === true)
                        )
                        &&
                        (value.text)
                        &&
                        <div className='my-3 text-break px-2'>
                          {seeMoreLess[value._id] ? value.text : value.text.slice(0, 50) + (value.text.length > 50 ? "..." : "")}

                          {
                            value.text.length > 50 
                            && 
                            <small className="text-primary cursor-pointer" onClick={() => handleSeeMoreLess(value._id)}>
                              {seeMoreLess[value._id] ? " See less..." : " See more..."}
                            </small>
                          }
                        </div>
                      }
                    </>
                  </div>
                </InView>
              ))
            }

            {/* Load More */}
            <>
              {
                showCnpLoadMore
                &&
                <div className='text-center mt-3 mb-1'>
                  <button type="button" className='btn btn-primary btn-sm' onClick={handleLoadMore}>Load More</button>
                </div>
              }
            </>
          </>
        }
      </section>
    </>
  )
}

export default CenterBlockPosts